import {Button, Checkbox, Col, Form, FormInstance, Input, Row, Select} from "antd"
import React, {useEffect, useState} from "react"
import {MinusOutlined} from "@ant-design/icons";
import {fiscalCodeFormItemValidator} from "../../common/fiscalCode.validator";
import CodiceFiscale from "codice-fiscale-js";
import {checkEnrollmentClassesByFiscalCode} from "../../service/enrollment.service";

export interface EnrollmentFormItem {
    readonly fiscalCode: string
    readonly name: string
    readonly surname: string
    readonly hasBadge: boolean
    readonly badge: string
    readonly classSolo: string
    readonly classDuo: string
    readonly classGroup: string
}

interface Props {
    readonly form: FormInstance
    readonly id: number
    readonly classes: ReadonlyArray<string>
    readonly restField: { fieldKey?: number | undefined }
    readonly onRemove: (id: number) => void
    readonly costWithBadge: number
    readonly costWithoutBadge: number
}

export const EnrollmentComponent = ({
                                        id,
                                        classes,
                                        restField,
                                        onRemove,
                                        form,
                                        costWithBadge,
                                        costWithoutBadge
                                    }: Props) => {

    const [showBadgeInput, setShowBadgeInput] = useState(false)
    const [enrollmentClassesMessage, setEnrollmentClassesMessage] = useState<string | undefined>(undefined)
    const [cost, setCost] = useState(costWithoutBadge)

    useEffect(() => {
        setShowBadgeInput(form.getFieldValue(["competitors", id, "badge"]))
        const fiscalCode = form.getFieldValue(["competitors", id, "fiscalCode"])

        if (fiscalCode !== undefined && fiscalCode.trim().length > 0) {
            validateFiscalCode(fiscalCode)
        }
    }, [])

    const onShowBadgeChange = (checked: boolean) => {
        setShowBadgeInput(checked)

        setCost(checked ? costWithBadge : costWithoutBadge)

        if (!checked) {
            form.setFieldValue(["competitors", id, "badge"], undefined)
        }
    }

    const handleFiscalCodeChange = (fiscalCode?: string): void => {
        if (fiscalCode !== undefined && fiscalCode.trim().length > 0) {
            form.setFieldValue(["competitors", id, "fiscalCode"], fiscalCode.trim())
            form.validateFields(["competitors", id, "fiscalCode"])

            validateFiscalCode(fiscalCode)
        }
    }

    const validateFiscalCode = (fiscalCode: string): void => {
        if (CodiceFiscale.check(fiscalCode)) {
            checkEnrollmentClassesByFiscalCode(fiscalCode).subscribe(value => {
                if (value !== undefined && value !== null) {
                    let message =
                        "Atleta trovato negli archivi, classi minime di appartenenza: "

                    if (value.classSolo.length > 0) {
                        message = message + "SOLO classe " + value.classSolo
                    }

                    if (value.classSolo.length > 0 && value.classDuo.length > 0) {
                        message = message + " e COPPIA/DUO classe " + value.classDuo
                    } else if (value.classDuo.length > 0) {
                        message = message + "Coppia/Duo classe " + value.classDuo
                    }

                    setEnrollmentClassesMessage(message)
                } else {
                    setEnrollmentClassesMessage("Nuovo tesserato.")
                }
            })
        }
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", marginTop: "20px", gap: "10px"}}>
                <Row style={{paddingLeft: 20, paddingRight: 20}}>
                    <Col span={24}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <h3 style={{margin: "0", textAlign: "center"}}>Costo: {cost} €</h3>
                            <Button onClick={() => onRemove(id)}><MinusOutlined style={{marginRight: '5px'}}/>
                                Rimuovi
                            </Button>
                        </div>
                    </Col>
                </Row>
                {
                    enrollmentClassesMessage && <Row style={{paddingLeft: 20, paddingRight: 20}}>
                        <Col span={24}>
                            <span style={{fontWeight: "bold"}}>{enrollmentClassesMessage}</span>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col sm={24} lg={24}>
                        <Row gutter={50} style={{paddingLeft: 20, paddingRight: 20}}>
                            <Col xs={24} lg={8}>
                                <Form.Item
                                    {...restField}
                                    label="Codice fiscale"
                                    name={[id, "fiscalCode"]}
                                    rules={[{
                                        required: true,
                                        message: 'Codice fiscale obbligatorio'
                                    }, fiscalCodeFormItemValidator]}>
                                    <Input onChange={event => handleFiscalCodeChange(event.target.value)}/>
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item
                                    {...restField}
                                    label="Nome"
                                    name={[id, "name"]}
                                    rules={[{required: true, message: 'Nome obbligatorio'}]}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={8}>
                                <Form.Item
                                    {...restField}

                                    label="Cognome"
                                    name={[id, "surname"]}
                                    rules={[{required: true, message: 'Cognome obbligatorio'}]}>
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={24} lg={24}>
                        <Row gutter={50} style={{paddingLeft: 20, paddingRight: 20}}>
                            <Col xs={24} lg={5}>
                                <Form.Item
                                    {...restField}
                                    label="Classe Solo"
                                    name={[id, "classSolo"]}
                                    rules={[{required: true, message: 'Classe Solo obbligatoria'}]}>
                                    <Select
                                        options={classes.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={5}>
                                <Form.Item
                                    {...restField}
                                    label="Classe Coppia/Duo"
                                    name={[id, "classDuo"]}
                                    rules={[{required: true, message: 'Classe Coppia/Duo obbligatoria'}]}>
                                    <Select
                                        options={classes.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={5}>
                                <Form.Item
                                    {...restField}
                                    label="Classe Gruppo"
                                    name={[id, "classGroup"]}>
                                    <Select
                                        options={classes.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} lg={9}>
                                <Row gutter={50}>
                                    <Col span={8}>
                                        <Form.Item
                                            label="Tesserato Ente">
                                            <Checkbox checked={showBadgeInput}
                                                      onChange={event => onShowBadgeChange(event.target.checked)}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        {showBadgeInput &&
                                            <Form.Item
                                                {...restField}
                                                label="Numero tessera"
                                                name={[id, "badge"]}
                                                rules={[{required: true, message: 'Numero tessera obbligatorio'}]}>
                                                <Input/>
                                            </Form.Item>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Form.Item style={{padding: 0, margin: 0}} shouldUpdate>
                    {
                        ({getFieldValue}) => {
                            const error = getFieldValue(['competitors', id, 'error'])
                            if (error === undefined || error === null || error === '') {
                                return null
                            }

                            return <span style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                color: "red"
                            }}>{error}</span>
                        }
                    }
                </Form.Item>
            </div>
        </>
    )
}
